export default __webpack_public_path__ + "static/media/bihorel14.c1ae621d.jpg";